/**
 * Décode un token JWT sans vérification de la signature
 * @param {string} token - Le token JWT à décoder
 * @returns {object|null} - L'objet décodé ou null en cas d'erreur
 */
export const decodeJWT = (token) => {
  try {
    if (!token) return null;
    
    // Un token JWT a la forme: header.payload.signature
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;
    
    // Remplacer les caractères spécifiques à base64url
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    
    // Décoder la chaîne base64
    const jsonPayload = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    
    return JSON.parse(jsonPayload);
  } catch (error) {
    console.error('Erreur lors du décodage du JWT:', error);
    return null;
  }
};

/**
 * Vérifie si l'utilisateur est administrateur en fonction de son token JWT
 * @param {string} token - Le token JWT
 * @returns {boolean} - true si l'utilisateur est administrateur, false sinon
 */
export const isAdmin = (token) => {
  const decoded = decodeJWT(token);
  if (!decoded) return false;
  
  // Vérifier si l'utilisateur est admin via user.role ou user.isAdmin
  const user = decoded.user || {};
  return user.role === 'admin' || user.isAdmin === true;
};
